export const IS_LOADER = 'IS_LOADER';
